module.exports = __webpack_public_path__ + "static/img/vip_icon_2.2916afe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member/vip_icon_2.png
// module id = 754
// module chunks = 1